// 路由白名单
export const whiteList = ['login', 'index', 'content', 'faq', 'windowsUpdate', 'privacyPolicy', 'sharelink', 'sendlink', "linkd", 'updatelog', 'updatelogWindows', 'updatelogAndroid', 'updatelogIphone', 'updatelogWindowsSync', 'updatelogIphoneSync', '404', 'login_terminal', 'caslogin', 'download', 'downloadAndroid', 'downloadIphone', 'downloadWindowsSync', 'downloadIphoneSync', 'encryption', 'applyTempAccount', 'delayTempAccount'];
// console.log(process.env)
// 系统配置参数
export const config = {
  api: process.env.VUE_APP_API,
  url: process.env.VUE_APP_URL,
  loginUrl: process.env.VUE_APP_LOGIN_URL,
}

// 支持预览的文本类型(后缀名)，同时需要修改icon.js中的open属性
export const previewTxts = [
  "html", "js", "json", "php", "java", "py", "c", "vue", "jsp", "asp", "h", "cpp", "cs", "aspx", "css", "md"
];

// 替换缩略图域名地址
const thumbDomain = process.env.VUE_APP_THUMB_DOMAIN;
export function replaceThumbDomain (url) {
  let urlReg = /^http(s)?:\/\/(.*?)\//;
  let imgPath = url.replace(urlReg, thumbDomain + "thumbnail/");
  return imgPath;
}